import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AuthContext } from '@@/contexts/AuthContext';
import { InsightsApiClient, GetConfigurationResult } from '../../api/api-client';
import { ResultValue } from '@@/types/ApiResult';

export const useConfiguration = () => {
  const { instanceData } = useContext(AuthContext);

  const fetchLog = async () => {
    if (!instanceData) {
      throw new Error('Instance data is not available');
    }

    const client = new InsightsApiClient();
    const result = await client.getConfiguration({
      instanceId: instanceData.instanceId,
      region: instanceData.region
    });

    if (!ResultValue.ok(result)) {
      throw new Error(result?.message || 'Failed to fetch real-time logs');
    }

    return result.data;
  };

  const {
    data,
    isLoading,
    error: apiError,
    isRefetching,
    refetch
  } = useQuery<GetConfigurationResult, Error>({
    queryKey: ['log', instanceData?.instanceId, instanceData?.region],
    queryFn: fetchLog,
    enabled: !!(instanceData?.instanceId && instanceData?.region),
    refetchOnWindowFocus: false,
    staleTime: 0,
    retry: 0
  });

  return {
    data,
    isLoading,
    isRefetching,
    error: apiError,
    refetch
  };
};
